import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useOnPremOrdersApi } from "../../../../common/api/orders-api/useOnPremOrdersApi";
import { OnPremOrderStatus } from "../../../common/types/OnPremOrderStatus";
import { mapOnPremOrderStatusName } from "../../common/utils/getAvailableOnPremOrderStatuses";
import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingItem } from "../OnPremOrderListingItem";

type OnPremOrderStatusDialogProps = {
    item: OnPremOrderListingItem;
    selectedStatus: OnPremOrderStatus;
    onClose: () => void;
};

export const OnPremOrderStatusDialog = ({
    item,
    selectedStatus,
    onClose
}: OnPremOrderStatusDialogProps): JSX.Element => {
    const { updateOnPremOrderStatus } = useOnPremOrdersApi();
    const { updateOnPremOrder } = useContext(OnPremOrderListingContext);
    const { success } = useNotifications();

    const updateStatus = async () => {
        await updateOnPremOrderStatus({ orderId: item.id, status: selectedStatus });

        success("On-Prem order status updated");

        updateOnPremOrder({ id: item.id, status: selectedStatus });
        onClose();
    };

    return (
        <ConfirmDialog
            title="Update On-Prem order status"
            text={`Are you sure you want to update On-Prem order status to ${mapOnPremOrderStatusName(
                selectedStatus
            )}?`}
            confirm={{ onClick: updateStatus }}
            cancel={{ onClick: onClose }}
        />
    );
};
